import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden px-4 py-20" data-id="element-77">
      {/* Watercolor Background Effect */}
      <div className="absolute inset-0 w-full h-full opacity-60 z-0 pointer-events-none" data-id="element-78">
        <div className="absolute top-[-10%] left-[-10%] w-[60%] h-[60%] rounded-full bg-sage-100 blur-[80px] opacity-70 mix-blend-multiply animate-pulse" style={{
        animationDuration: '8s'
      }} data-id="element-79" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[60%] h-[60%] rounded-full bg-cream-200 blur-[80px] opacity-70 mix-blend-multiply" data-id="element-80" />
        <div className="absolute top-[40%] left-[60%] w-[40%] h-[40%] rounded-full bg-sage-50 blur-[60px] opacity-60 mix-blend-multiply" data-id="element-81" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-82">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-83">
          <span className="inline-block text-sage-600 font-medium tracking-wide text-sm md:text-base mb-6 uppercase" data-id="element-84">
            Un protocolo dermatológico de 14 días
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="font-serif text-5xl md:text-7xl lg:text-8xl text-warm-900 mb-8 leading-[1.1]" data-id="element-85">
          Tu cuero cabelludo <br className="hidden md:block" data-id="element-86" />
          <span className="italic text-sage-700" data-id="element-87">no está fallando.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-lg md:text-xl text-warm-600 max-w-xl mx-auto mb-12 leading-relaxed" data-id="element-88">
          Solo necesita que alguien le explique qué hacer — paso a paso, sin
          ruido, sin miedo.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} transition={{
        duration: 0.9,
        delay: 0.7
      }} className="mb-12" data-id="element-89">
          <img src="https://cdn.magicpatterns.com/uploads/weGiYHTGF1DpAXRgWwf8N6/imagen_prodct.png" alt="Protocolo Cuero Cabelludo en Calma - Vista previa del producto" className="w-64 md:w-80 h-auto mx-auto rounded-2xl shadow-xl" data-id="element-90" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} data-id="element-91">
          <button onClick={scrollToPricing} className="group bg-sage-500 hover:bg-sage-600 text-white text-lg font-medium px-8 py-4 rounded-full transition-all duration-300 shadow-lg shadow-sage-200 hover:shadow-sage-300 flex items-center gap-2 mx-auto" data-id="element-92">
            Descubre el protocolo
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-93" />
          </button>
        </motion.div>
      </div>
    </section>;
}